const routes = [
  {
    index: true,
    label: "Julian Alvarez",
    path: "/",
  },
  {
    label: "Story",
    path: "/story",
  },
  {
    label: "About",
    path: "/about",
  },
  {
    label: "Jungle",
    path: "/Jungle",
  },
  {
    label: "Podcast",
    path: "/podcast",
  },
  {
    label: "Contact",
    path: "/contact",
  },
];

export default routes;
